import React from 'react';
import { useRequest } from 'ahooks';
import { api } from "@redux/api";
import PeiChart from "@containers/facility/Overview/PieChart";
import { useAuth } from '@/hooks/use-auth';
import { Nopermission } from '@/components/Nopermission';
import { useNavigate } from 'react-router-dom';
import { emitEvent } from '@/hooks/useEventBus';
import { useDispatch, useSelector } from 'react-redux';
import appActions from '@redux/app/actions';
import { buildFacilityPath, getFacilityContext } from '@/utils/route-context';

const EquipmentByConditionChart = () => {
    const equipmentPermission = useAuth('equipment', 1);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const facilityId = useSelector(state => state?.Facility?.selected?.Id);
    const facilityContext = useSelector((state) => getFacilityContext(state));

    const { data: equipmentData } = useRequest(
        () => api.allequipmentview(),
        {
            ready: equipmentPermission,
            cacheKey: `equipment-condition-chart-data-${facilityId}`,
            staleTime: 1 * 60 * 1000, // 1分钟缓存
        }
    );

    if (!equipmentPermission) {
        return <Nopermission />;
    }

    const equipmentConditionData = equipmentData?.data?.grouped_status_data;

    if (!equipmentConditionData) {
        return null
    }

    const handleEquipmentConditionClick = (e) => {
        emitEvent('CLOSE_EQUIPMENT');
        const url = buildFacilityPath('equipment', {
            ...facilityContext,
            query: { condition: e.data.name },
        }) || '/switch-view';
        navigate(url);
        dispatch(appActions.changeCurrent(['equipment']));
    };

    return (
        <PeiChart
            data={equipmentConditionData}
            height={200}
            title={'Equipment by Condition'}
            handleChartClick={handleEquipmentConditionClick}
        />
    );
};

export default EquipmentByConditionChart; 
